<ng-container *transloco="let t">
<loading-indicator [heading]="t('portal.eConsent.loadingHeading')"
  [message1]="t('portal.eConsent.loadingMessage1')"
  [message2]="t('portal.eConsent.loadingMessage2')">
</loading-indicator>
</ng-container>
